import React, { useMemo } from 'react';
import withHover from '../../hocs/withHover';
import withFocus from '../../hocs/withFocus';
import useNavItemStyles from './utils/useNavItemStyles';
import ItemBody from './ItemBody';
import { ClickableOpacity } from '../ClickableOpacity';
import useTheme from 'branding/theme';
import handleStickyFocus from '../../utils/handleStickyFocus';
export const HandlerNavItem = ({ onClick, children, description, infoText, isHovered, handleMouseEnter, handleMouseLeave, isFocused, handleFocus, handleBlur, styles }) => {
    const { utility } = useTheme();
    const navItemStyles = useNavItemStyles(isFocused || isHovered, styles);
    const mergedStyles = useMemo(() => ({ ...navItemStyles, ...utility.size.fullWidthStyles }), [navItemStyles, utility]);
    const handleClick = handleStickyFocus(handleBlur, onClick);
    const props = useMemo(() => ({
        handleMouseEnter,
        handleMouseLeave,
        handleFocus,
        handleBlur,
        isHovered,
        isFocused,
        onClick: handleClick,
        styles: mergedStyles
    }), [
        handleFocus,
        handleBlur,
        handleMouseEnter,
        handleMouseLeave,
        handleClick,
        mergedStyles,
        isHovered,
        isFocused
    ]);
    return (React.createElement(ClickableOpacity, { alt: "", ...props },
        React.createElement(ItemBody, { description: description, infoText: infoText }, children)));
};
export default withHover(withFocus(HandlerNavItem));
//# sourceMappingURL=HandlerNavtem.js.map